import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';

import { Button, Modal, ModalFooter, ModalBody } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/ModalHeader.css';
import '@spotahome/ui-library/lib/components/ModalBody.css';
import '@spotahome/ui-library/lib/components/ModalFooter.css';

import './AlertModalContainer.scss';

const getButtonKeys = isDelete =>
  isDelete
    ? {
        acceptKey: 'alerts.modal.button.accept.delete',
        cancelKey: 'alerts.modal.button.cancel.delete'
      }
    : {
        acceptKey: 'alerts.modal.button.accept',
        cancelKey: 'alerts.modal.button.cancel'
      };

class AlertModalContainer extends PureComponent {
  static propTypes = {
    cancel: PropTypes.func.isRequired,
    accept: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDelete: PropTypes.bool
  };

  static defaultProps = {
    hasError: false,
    isOpen: false,
    isLoading: false,
    isDelete: false
  };

  closeModal = () => {
    if (!this.props.isLoading) {
      this.props.cancel();
    }
  };

  render() {
    const { acceptKey, cancelKey } = getButtonKeys(this.props.isDelete);

    return (
      <Modal
        isOpen={this.props.isOpen}
        contentLabel="modal"
        onRequestClose={this.closeModal}
        className="alert-modal"
        size="medium"
      >
        <ModalBody className="alert-modal__body">
          {this.props.children}
        </ModalBody>
        <ModalFooter className="alert-modal__footer">
          <div className="alert-modal__button-wrapper">
            <Button
              disabled={this.props.isLoading}
              size="big"
              alt
              onClick={this.props.cancel}
              className="alert-modal__footer-button"
            >
              {trans(cancelKey)}
            </Button>
            <Button
              disabled={this.props.hasError || this.props.isLoading}
              size="big"
              onClick={this.props.accept}
              className="alert-modal__footer-button"
            >
              {trans(acceptKey)}
            </Button>
          </div>
          {!this.props.isDelete && (
            <p className="alert-modal__disclaimer">
              {trans('alerts.modal.footer_message')}
            </p>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default AlertModalContainer;
